import React, { useState, useEffect, useContext } from 'react';
import {Route, Routes} from "react-router-dom";

import Reg_Home from './reg/home.js';
import Reg_Kreg from './reg/kreg.js';
import Reg_Lreg from './reg/lreg.js';
import {withRouter} from "../lib/react/withRouter";
import Bo_Home from "./bo/home";

function pg_home() {

    var html =
    <div className="web-content">
      Hem
    </div>
    ;
    return html;
}

class Bfs_Reg extends React.Component {
    //var sdo = useContext(SDO);
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.state = {};
  }
  fknGo(row) {
    //alert(row.href);
    this.props.navigate(row.url);
  }

  render() {
      var path = window.location.pathname;
      if(path.substr(-1) == "/") path = path.substring(0, path.length - 1);
      var op = path.split("/").pop();
      var po = {};
      po.kreg = { "fid": "f05", "url": "/bfs/reg/kreg", "name": "Kunder", "active": false };
      po.lreg = { "fid": "f05", "url": "/bfs/reg/lreg", "name": "Leverantörer", "active": false };
      if(po[op]) {
          po[op].active = true;
          this.props.store.fkn = po[op];
      }
      var pa = Object.values(po);

    return (

    <div className="web-app">
         { this.props.store.cfg.bread ?
        <div className="web-bread">
            <div className="breadcrumb">
            { pa.map((row, key) =>
                <div key={key} className="breadcrumb-item" active={row.active} onClick={() => this.fknGo(row)}>{row.name}</div>
            )}
            <div className="flex"></div>
            <div className="cdigreen">{ this.props.store.fkn ? this.props.store.fkn.name : null }</div>
            </div>
        </div>
        : null }
        <Routes>
          <Route path="/xx" component={pg_home} />
            <Route path="kreg" element={ <Reg_Kreg store={this.store} />} />
            <Route path="lreg" element={ <Reg_Lreg store={this.store} />} />
            <Route path="*" element={ <Reg_Home store={this.store} />} />
        </Routes>
    </div>

  );
}
}
//Sys.contextType = ADOContext;

export default withRouter(Bfs_Reg);
